import React from 'react';
import '../Styling/cards.css';
import '../Styling/days.css';
import ContactForm from '../Components/contactForm';


export default function Day2() {
    return (<>
    <div id="rootAlign">
    
<div className='dayDescription'>
Day 2 offers an immersive journey through Jaipur's majestic heritage and enchanting nightscape. Begin by exploring the grandeur of the Amber Fort, witnessing its stunning architecture and historical significance. Experience the precision of ancient astronomy at Jantar Mantar, and delve into diverse artifacts at the cultural repository of Albert Hall. After a luxurious interlude, witness the mesmerizing charm of Jaipur at night, where the city comes alive under the moon's glow. Complete your day with a homely stay, offering authentic cultural experiences and home-cooked delicacies, inviting you to live and breathe the essence of India.
    </div>

    <div className="dayHeading day2Heading"></div>


    <div className="daysContainer bgImgRight bgImg1">
      <div className='align'>

      <div className="dayDesc day2Desc1"></div>
      <div className="dayCard day2Card1"></div>
      </div>
    </div>


    <div className="daysContainer bgImgLeft bgImg2">
      <div className='align'>

      <div className="dayDesc day2Desc2"></div>
      <div className="dayCard day2Card2"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg3">
      <div className='align'>   

      <div className="dayDesc day2Desc3"></div>
      <div className="dayCard day2Card3"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg4">
      <div className='align'>

      <div className="dayDesc day2Desc4"></div>
      <div className="dayCard day2Card4"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg5">
      <div className='align'>

      <div className="dayDesc day2Desc5"></div>
      <div className="dayCard day2Card5"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg6">
      <div className='align'>

      <div className="dayDesc day2Desc6"></div>
      <div className="dayCard day2Card6"></div>
      </div>
    </div>

</div>
<ContactForm/>

    </> );
};